(() => {
  // src/scripts/entries/back-in-stock/boh-back-in-stock-klaviyo.js
  var KLAVIYO_BIS_ENDPOINT = "https://a.klaviyo.com/client/back-in-stock-subscriptions/";
  var KLAVIYO_SUBSCRIPTIONS_ENDPOINT = "https://a.klaviyo.com/client/subscriptions/";
  var KLAVIYO_REVISION = "2026-01-15";
  var KLAVIYO_CLIENT_SUBSCRIPTIONS_REVISION = "2026-01-15";
  function buildEmailPayload(email, variantId) {
    return {
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: { email }
            }
          },
          channels: ["EMAIL"]
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: `$shopify:::$default:::${variantId}`
            }
          }
        }
      }
    };
  }
  function buildSmsBackInStockPayload(phoneNumber, variantId) {
    return {
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: { phone_number: phoneNumber }
            }
          },
          channels: ["SMS"]
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: `$shopify:::$default:::${variantId}`
            }
          }
        }
      }
    };
  }
  function buildMarketingConsentPayload(email, emailListId) {
    return {
      data: {
        type: "subscription",
        attributes: {
          custom_source: "Back in Stock",
          profile: {
            data: {
              type: "profile",
              attributes: {
                email,
                subscriptions: {
                  email: {
                    marketing: {
                      consent: "SUBSCRIBED"
                    }
                  }
                }
              }
            }
          }
        },
        relationships: emailListId ? {
          list: {
            data: {
              type: "list",
              id: emailListId
            }
          }
        } : void 0
      }
    };
  }
  function buildSmsMarketingConsentPayload(phoneNumber, smsListId) {
    return {
      data: {
        type: "subscription",
        attributes: {
          custom_source: "Back in Stock",
          profile: {
            data: {
              type: "profile",
              attributes: {
                phone_number: phoneNumber,
                subscriptions: {
                  sms: {
                    marketing: {
                      consent: "SUBSCRIBED"
                    }
                  }
                }
              }
            }
          }
        },
        relationships: smsListId ? {
          list: {
            data: {
              type: "list",
              id: smsListId
            }
          }
        } : void 0
      }
    };
  }
  async function parseKlaviyoErrorResponse(response) {
    var _a, _b;
    try {
      const data = await response.json();
      const detail = ((_b = (_a = data == null ? void 0 : data.errors) == null ? void 0 : _a[0]) == null ? void 0 : _b.detail) || (data == null ? void 0 : data.message);
      if (detail) {
        return detail;
      }
    } catch (error) {
    }
    return `Klaviyo request failed (${response.status}).`;
  }
  async function postJson(url, body, { revision, jsonApi = false }) {
    const headers = jsonApi ? {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
      revision
    } : {
      "Content-Type": "application/json",
      revision
    };
    const response = await fetch(url, {
      method: "POST",
      headers,
      body: JSON.stringify(body)
    });
    if (!response.ok) {
      throw new Error(await parseKlaviyoErrorResponse(response));
    }
  }
  async function submitEmailBackInStockSubscription({
    email,
    variantId,
    companyId
  }) {
    await postJson(
      `${KLAVIYO_BIS_ENDPOINT}?company_id=${encodeURIComponent(companyId)}`,
      buildEmailPayload(email, variantId),
      { revision: KLAVIYO_REVISION }
    );
  }
  async function submitSmsBackInStockSubscription({
    phoneNumber,
    variantId,
    companyId
  }) {
    await postJson(
      `${KLAVIYO_BIS_ENDPOINT}?company_id=${encodeURIComponent(companyId)}`,
      buildSmsBackInStockPayload(phoneNumber, variantId),
      { revision: KLAVIYO_REVISION }
    );
  }
  async function submitEmailMarketingConsent({
    email,
    emailListId,
    companyId
  }) {
    await postJson(
      `${KLAVIYO_SUBSCRIPTIONS_ENDPOINT}?company_id=${encodeURIComponent(companyId)}`,
      buildMarketingConsentPayload(email, emailListId),
      { revision: KLAVIYO_CLIENT_SUBSCRIPTIONS_REVISION, jsonApi: true }
    );
  }
  async function submitSmsMarketingConsent({
    phoneNumber,
    smsListId,
    companyId,
    missingSmsListMessage
  }) {
    if (!smsListId) {
      throw new Error(missingSmsListMessage || "Missing Klaviyo SMS list ID");
    }
    await postJson(
      `${KLAVIYO_SUBSCRIPTIONS_ENDPOINT}?company_id=${encodeURIComponent(companyId)}`,
      buildSmsMarketingConsentPayload(phoneNumber, smsListId),
      { revision: KLAVIYO_CLIENT_SUBSCRIPTIONS_REVISION, jsonApi: true }
    );
  }

  // src/scripts/entries/back-in-stock/boh-back-in-stock-messages.js
  function readMessageValue(source, path) {
    return path.split(".").reduce((value, key) => {
      if (value && typeof value === "object" && key in value) {
        return value[key];
      }
      return void 0;
    }, source);
  }
  function createBackInStockTranslator(messages) {
    const dictionary = messages && typeof messages === "object" ? messages : {};
    return function t(path) {
      const value = readMessageValue(dictionary, path);
      return typeof value === "string" ? value : "";
    };
  }

  // src/scripts/entries/back-in-stock/boh-back-in-stock-phone.js
  var LIBPHONENUMBER_SCRIPT_URL = "https://cdn.jsdelivr.net/npm/libphonenumber-js@1.11.17/bundle/libphonenumber-max.js";
  var libPhoneNumberPromise;
  function getDefaultPhoneCountry(countryValue) {
    const country = String(countryValue || "GB").trim().toUpperCase();
    if (/^[A-Z]{2}$/.test(country)) {
      return country;
    }
    return "GB";
  }
  async function loadLibPhoneNumber() {
    var _a;
    if (typeof ((_a = window.libphonenumber) == null ? void 0 : _a.parsePhoneNumberFromString) === "function") {
      return window.libphonenumber;
    }
    if (!libPhoneNumberPromise) {
      libPhoneNumberPromise = new Promise((resolve, reject) => {
        const existingScript = document.querySelector(
          "script[data-libphonenumber-js]"
        );
        if (existingScript) {
          existingScript.addEventListener(
            "load",
            () => resolve(window.libphonenumber),
            { once: true }
          );
          existingScript.addEventListener("error", reject, { once: true });
          return;
        }
        const script = document.createElement("script");
        script.src = LIBPHONENUMBER_SCRIPT_URL;
        script.async = true;
        script.dataset.libphonenumberJs = "true";
        script.onload = () => resolve(window.libphonenumber);
        script.onerror = reject;
        document.head.append(script);
      }).then((libphonenumber) => {
        if (typeof (libphonenumber == null ? void 0 : libphonenumber.parsePhoneNumberFromString) !== "function") {
          throw new Error("libphonenumber-js did not load");
        }
        return libphonenumber;
      });
    }
    return libPhoneNumberPromise;
  }
  async function normalisePhoneNumber(value, defaultCountryInput) {
    if (!value) {
      return "";
    }
    const trimmed = value.trim();
    if (!trimmed) {
      return "";
    }
    const normalised = trimmed.replace(/[\s().-]/g, "");
    const defaultCountry = getDefaultPhoneCountry(defaultCountryInput);
    const internationalCandidate = normalised.startsWith("00") ? `+${normalised.slice(2)}` : normalised;
    try {
      const libphonenumber = await loadLibPhoneNumber();
      const parse = libphonenumber.parsePhoneNumberFromString;
      const parsedInternational = internationalCandidate.startsWith("+") ? parse(internationalCandidate) : null;
      if (parsedInternational == null ? void 0 : parsedInternational.isValid()) {
        return parsedInternational.number;
      }
      const parsedLocal = parse(normalised, defaultCountry);
      if (parsedLocal == null ? void 0 : parsedLocal.isValid()) {
        return parsedLocal.number;
      }
    } catch (error) {
    }
    if (/^00\d{8,15}$/.test(normalised)) {
      return `+${normalised.slice(2)}`;
    }
    if (/^\+\d{8,15}$/.test(normalised)) {
      return normalised;
    }
    const digitsOnly = normalised.replace(/\D/g, "");
    if (/^07\d{9}$/.test(digitsOnly)) {
      return `+44${digitsOnly.slice(1)}`;
    }
    if (/^44\d{9,14}$/.test(digitsOnly)) {
      return `+${digitsOnly}`;
    }
    return null;
  }

  // src/scripts/entries/back-in-stock/boh-back-in-stock.js
  var BackInStock = class extends HTMLElement {
    constructor() {
      var _a;
      super();
      this.currentVariantId = null;
      this.dialog = null;
      this.dialogLifecycleActive = false;
      this.dialogPointerDownOutside = false;
      this.productForm = null;
      this.form = null;
      this.emailInput = null;
      this.phoneInput = null;
      this.submitButton = null;
      this.triggerButton = null;
      this.addToCartButton = null;
      this.closeButton = null;
      this.acceptsMarketingInput = null;
      this.phoneErrorElement = null;
      this.statusElement = null;
      this.lastTriggerButton = null;
      this.variantEventSource = null;
      this.t = createBackInStockTranslator((_a = window.Bohomoon) == null ? void 0 : _a.backInStockMessages);
      this.onSubmit = this.onSubmit.bind(this);
      this.onVariantChanged = this.onVariantChanged.bind(this);
      this.onCloseClick = this.onCloseClick.bind(this);
      this.onTriggerClick = this.onTriggerClick.bind(this);
      this.onPhoneInput = this.onPhoneInput.bind(this);
      this.onDialogClick = this.onDialogClick.bind(this);
      this.onDialogClose = this.onDialogClose.bind(this);
      this.onDialogPointerDown = this.onDialogPointerDown.bind(this);
      this.onDocumentVariantChanged = this.onDocumentVariantChanged.bind(this);
      this.onProductRerender = this.onProductRerender.bind(this);
    }
    connectedCallback() {
      var _a, _b, _c;
      this.dialog = this.querySelector("[data-bis-dialog]");
      this.form = this.querySelector("form");
      this.emailInput = this.querySelector('input[type="email"]');
      this.phoneInput = this.querySelector('input[type="tel"]');
      this.submitButton = this.querySelector('[type="submit"]');
      this.closeButton = this.querySelector("[data-bis-close]");
      this.acceptsMarketingInput = this.querySelector(
        'input[name="accepts_marketing"]'
      );
      this.phoneErrorElement = this.querySelector("[data-bis-phone-error]");
      this.statusElement = this.querySelector("[data-bis-status]");
      if (!this.statusElement) {
        this.statusElement = document.createElement("p");
        this.statusElement.className = "back-in-stock__status";
        this.statusElement.setAttribute("data-bis-status", "");
        this.statusElement.setAttribute("role", "status");
        this.statusElement.setAttribute("aria-live", "polite");
        const body = this.querySelector(".back-in-stock__body");
        if (body) {
          body.append(this.statusElement);
        }
      }
      this.syncProductFormControls();
      this.setInitialVariantId();
      this.updateAvailabilityUi(this.getInitialAvailability());
      if (this.form) {
        this.form.addEventListener("submit", this.onSubmit);
      }
      (_a = this.dialog) == null ? void 0 : _a.addEventListener("click", this.onDialogClick);
      (_b = this.dialog) == null ? void 0 : _b.addEventListener("close", this.onDialogClose);
      (_c = this.dialog) == null ? void 0 : _c.addEventListener("pointerdown", this.onDialogPointerDown);
      if (this.closeButton) {
        this.closeButton.addEventListener("click", this.onCloseClick);
      }
      if (this.phoneInput) {
        this.phoneInput.addEventListener("input", this.onPhoneInput);
      }
      this.variantEventSource = this.closest("quick-buy-drawer, quick-buy-popover") || document;
      this.variantEventSource.addEventListener(
        "variant:changed",
        this.onDocumentVariantChanged
      );
      this.variantEventSource.addEventListener(
        "product:rerender",
        this.onProductRerender,
        true
      );
    }
    disconnectedCallback() {
      var _a, _b, _c, _d, _e;
      if (this.form) {
        this.form.removeEventListener("submit", this.onSubmit);
      }
      (_a = this.dialog) == null ? void 0 : _a.removeEventListener("click", this.onDialogClick);
      (_b = this.dialog) == null ? void 0 : _b.removeEventListener("close", this.onDialogClose);
      (_c = this.dialog) == null ? void 0 : _c.removeEventListener("pointerdown", this.onDialogPointerDown);
      this.dialogLifecycleActive = false;
      this.dialogPointerDownOutside = false;
      this.unlockScroll();
      if (this.closeButton) {
        this.closeButton.removeEventListener("click", this.onCloseClick);
      }
      if (this.phoneInput) {
        this.phoneInput.removeEventListener("input", this.onPhoneInput);
      }
      if (this.triggerButton) {
        this.triggerButton.removeEventListener("click", this.onTriggerClick);
      }
      (_d = this.variantEventSource) == null ? void 0 : _d.removeEventListener(
        "variant:changed",
        this.onDocumentVariantChanged
      );
      (_e = this.variantEventSource) == null ? void 0 : _e.removeEventListener(
        "product:rerender",
        this.onProductRerender,
        true
      );
      this.variantEventSource = null;
    }
    findProductForm() {
      const productFormId = this.getAttribute("product-form");
      const productFormContainer = this.closest(".product-form");
      if (productFormId) {
        if (productFormContainer) {
          const scopedForm = productFormContainer.querySelector(
            `#${CSS.escape(productFormId)}`
          );
          if (scopedForm == null ? void 0 : scopedForm.matches("form")) {
            return scopedForm;
          }
        }
        const formById = document.getElementById(productFormId);
        if (formById == null ? void 0 : formById.matches("form")) {
          return formById;
        }
      }
      if (!productFormContainer) {
        return null;
      }
      return productFormContainer.querySelector(
        'form[is="product-form"], form[id^="product-form-"]'
      );
    }
    setInitialVariantId() {
      if (!this.productForm) {
        return;
      }
      const variantInput = this.productForm.querySelector('input[name="id"]');
      if (variantInput && variantInput.value) {
        this.currentVariantId = String(variantInput.value);
      }
    }
    onVariantChanged(event) {
      var _a;
      const variant = (_a = event == null ? void 0 : event.detail) == null ? void 0 : _a.variant;
      const variantId = variant == null ? void 0 : variant.id;
      if (variantId) {
        this.currentVariantId = String(variantId);
      }
      this.updateAvailabilityUi(variant);
    }
    onDocumentVariantChanged(event) {
      var _a, _b;
      const productFormId = this.getAttribute("product-form");
      const eventTarget = event == null ? void 0 : event.target;
      const eventTargetFormId = ((_a = eventTarget == null ? void 0 : eventTarget.getAttribute) == null ? void 0 : _a.call(eventTarget, "id")) || null;
      if (productFormId && eventTargetFormId !== productFormId) {
        return;
      }
      if ((_b = eventTarget == null ? void 0 : eventTarget.matches) == null ? void 0 : _b.call(eventTarget, "form")) {
        this.syncProductFormControls(eventTarget);
      } else {
        this.syncProductFormControls();
      }
      this.onVariantChanged(event);
    }
    onProductRerender(event) {
      var _a, _b;
      const productFormId = this.getAttribute("product-form");
      const eventTargetFormId = ((_b = (_a = event == null ? void 0 : event.target) == null ? void 0 : _a.getAttribute) == null ? void 0 : _b.call(_a, "id")) || null;
      if (productFormId && eventTargetFormId !== productFormId) {
        return;
      }
      queueMicrotask(() => {
        if (this.isConnected) {
          this.syncProductFormControls();
        }
      });
    }
    syncProductFormControls(productForm = null) {
      var _a;
      const productFormId = this.getAttribute("product-form");
      const nextProductForm = ((_a = productForm == null ? void 0 : productForm.matches) == null ? void 0 : _a.call(productForm, "form")) ? productForm : this.findProductForm();
      const localContainer = this.closest(".product-form");
      let nextTriggerButton = (nextProductForm == null ? void 0 : nextProductForm.querySelector("[data-bis-trigger]")) || null;
      let nextAddToCartButton = (nextProductForm == null ? void 0 : nextProductForm.querySelector("[data-product-add-to-cart-button]")) || null;
      if ((!nextTriggerButton || !nextAddToCartButton) && productFormId) {
        const scopedRoot = localContainer || this.closest(
          'quick-buy-drawer, quick-buy-popover, [id^="shopify-section-"]'
        ) || document;
        const escapedFormId = CSS.escape(productFormId);
        nextTriggerButton = nextTriggerButton || scopedRoot.querySelector(
          `[data-bis-trigger][form="${escapedFormId}"]`
        ) || null;
        nextAddToCartButton = nextAddToCartButton || scopedRoot.querySelector(
          `[data-product-add-to-cart-button][form="${escapedFormId}"]`
        ) || null;
      }
      if (!nextTriggerButton && localContainer) {
        nextTriggerButton = localContainer.querySelector("[data-bis-trigger]") || null;
      }
      if (!nextAddToCartButton && localContainer) {
        nextAddToCartButton = localContainer.querySelector("[data-product-add-to-cart-button]") || null;
      }
      if (this.triggerButton && this.triggerButton !== nextTriggerButton) {
        this.triggerButton.removeEventListener("click", this.onTriggerClick);
      }
      if (nextTriggerButton && this.triggerButton !== nextTriggerButton) {
        nextTriggerButton.addEventListener("click", this.onTriggerClick);
      }
      this.productForm = nextProductForm;
      this.triggerButton = nextTriggerButton;
      this.addToCartButton = nextAddToCartButton;
    }
    onCloseClick() {
      this.closeDialog();
    }
    onTriggerClick(event) {
      this.lastTriggerButton = (event == null ? void 0 : event.currentTarget) || this.triggerButton || null;
      if (this.isDialogOpen()) {
        this.closeDialog();
      } else {
        this.openDialog();
      }
    }
    onPhoneInput() {
      this.clearPhoneError();
      this.setStatus("");
    }
    onDialogPointerDown(event) {
      this.dialogPointerDownOutside = this.isBackdropPointerEvent(event);
    }
    onDialogClick(event) {
      const shouldClose = this.dialogPointerDownOutside && this.isBackdropPointerEvent(event);
      this.dialogPointerDownOutside = false;
      if (shouldClose) {
        this.closeDialog();
      }
    }
    onDialogClose() {
      if (!this.dialogLifecycleActive) {
        return;
      }
      this.dialogLifecycleActive = false;
      this.dialogPointerDownOutside = false;
      this.unlockScroll();
      this.resetDialogForm();
      this.restoreFocusToTrigger();
    }
    getInitialAvailability() {
      if (this.addToCartButton) {
        return { available: !this.addToCartButton.hasAttribute("disabled") };
      }
      const value = this.dataset.selectedVariantAvailable;
      if (value === "true") {
        return { available: true };
      }
      if (value === "false") {
        return { available: false };
      }
      return null;
    }
    updateAvailabilityUi(variant) {
      if (!this.triggerButton || !this.addToCartButton) {
        return;
      }
      const isSoldOut = Boolean(variant && variant.available === false);
      this.triggerButton.toggleAttribute("hidden", !isSoldOut);
      this.addToCartButton.toggleAttribute("hidden", isSoldOut);
      this.triggerButton.setAttribute("aria-hidden", String(!isSoldOut));
      this.addToCartButton.setAttribute("aria-hidden", String(isSoldOut));
      this.syncStandaloneAddToCartButton(variant);
      if (!isSoldOut && this.isDialogOpen()) {
        this.closeDialog();
      }
    }
    syncStandaloneAddToCartButton(variant) {
      var _a, _b;
      if (!this.addToCartButton) {
        return;
      }
      const labelElement = this.addToCartButton.querySelector(
        "[data-product-add-to-cart-button-label]"
      );
      if (labelElement) {
        return;
      }
      if (!variant || variant.available === false) {
        this.addToCartButton.setAttribute("disabled", "disabled");
        this.addToCartButton.classList.remove("button--secondary");
        this.addToCartButton.classList.add("button--ternary");
        this.addToCartButton.textContent = ((_b = (_a = window.themeVariables) == null ? void 0 : _a.strings) == null ? void 0 : _b.productFormSoldOut) || "Sold out";
        return;
      }
      this.addToCartButton.removeAttribute("disabled");
      this.addToCartButton.classList.remove("button--ternary");
      this.addToCartButton.textContent = this.addToCartButton.getAttribute("data-button-content") || this.addToCartButton.textContent;
    }
    isDialogOpen() {
      var _a;
      return Boolean((_a = this.dialog) == null ? void 0 : _a.open);
    }
    isBackdropPointerEvent(event) {
      if (!this.dialog || event.target !== this.dialog) {
        return false;
      }
      const dialogBounds = this.dialog.getBoundingClientRect();
      return event.clientX < dialogBounds.left || event.clientX > dialogBounds.right || event.clientY < dialogBounds.top || event.clientY > dialogBounds.bottom;
    }
    openDialog() {
      if (!this.dialog || this.dialog.open) {
        return;
      }
      if (typeof this.dialog.showModal === "function") {
        this.dialog.showModal();
      } else {
        this.dialog.setAttribute("open", "");
      }
      this.dialogLifecycleActive = true;
      this.lockScroll();
      this.focusInitialElement();
    }
    closeDialog() {
      var _a;
      if (!((_a = this.dialog) == null ? void 0 : _a.open)) {
        return;
      }
      if (typeof this.dialog.close === "function") {
        this.dialog.close();
      } else {
        this.dialog.removeAttribute("open");
      }
      this.onDialogClose();
    }
    focusInitialElement() {
      var _a;
      const preferredFocusTarget = this.emailInput || this.closeButton || this.getFocusableElements()[0] || this.dialog;
      (_a = preferredFocusTarget == null ? void 0 : preferredFocusTarget.focus) == null ? void 0 : _a.call(preferredFocusTarget, { preventScroll: true });
    }
    restoreFocusToTrigger() {
      const trigger = this.lastTriggerButton;
      if (!(trigger == null ? void 0 : trigger.isConnected) || trigger.hasAttribute("hidden") || trigger.hasAttribute("disabled")) {
        return;
      }
      trigger.focus({ preventScroll: true });
    }
    getFocusableElements() {
      return Array.from(
        this.querySelectorAll(
          'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      ).filter((element) => {
        if (element.hasAttribute("hidden") || element.getAttribute("aria-hidden") === "true") {
          return false;
        }
        return element.getClientRects().length > 0;
      });
    }
    lockScroll() {
      var _a, _b, _c;
      document.documentElement.classList.add("lock-all");
      (_a = document.body) == null ? void 0 : _a.classList.add("lock-all");
      (_c = (_b = this.closest("quick-buy-drawer, quick-buy-popover")) == null ? void 0 : _b.querySelector(".drawer__content")) == null ? void 0 : _c.classList.add("lock-all");
    }
    unlockScroll() {
      var _a, _b, _c;
      document.documentElement.classList.remove("lock-all");
      (_a = document.body) == null ? void 0 : _a.classList.remove("lock-all");
      (_c = (_b = this.closest("quick-buy-drawer, quick-buy-popover")) == null ? void 0 : _b.querySelector(".drawer__content")) == null ? void 0 : _c.classList.remove("lock-all");
    }
    async onSubmit(event) {
      var _a, _b, _c, _d;
      event.preventDefault();
      if (!this.form) {
        return;
      }
      this.setLoading(false);
      const email = ((_b = (_a = this.emailInput) == null ? void 0 : _a.value) == null ? void 0 : _b.trim()) || "";
      const phoneNumber = await normalisePhoneNumber(
        (_c = this.phoneInput) == null ? void 0 : _c.value,
        this.dataset.defaultPhoneCountry
      );
      const acceptsMarketing = Boolean((_d = this.acceptsMarketingInput) == null ? void 0 : _d.checked);
      this.clearPhoneError();
      if (email && this.emailInput && !this.emailInput.checkValidity()) {
        this.emailInput.reportValidity();
        return;
      }
      if (!email && !phoneNumber) {
        this.setStatus(this.t("validation.emailOrPhoneRequired"), "error");
        return;
      }
      if (this.phoneInput && this.phoneInput.value.trim() && !phoneNumber) {
        this.setPhoneError(this.t("validation.invalidPhone"));
        return;
      }
      if (phoneNumber && !this.getKlaviyoSmsListId()) {
        this.setPhoneError(this.t("errors.smsUnavailable"));
        return;
      }
      if (acceptsMarketing && !email) {
        this.setStatus(this.t("validation.emailRequiredForMarketing"), "error");
        return;
      }
      if (acceptsMarketing && !this.getKlaviyoEmailListId()) {
        this.setStatus(this.t("errors.emailMarketingUnavailable"), "error");
        return;
      }
      if (!this.currentVariantId) {
        this.setStatus(this.t("errors.variantUnavailable"), "error");
        return;
      }
      const companyId = this.getKlaviyoCompanyId();
      if (!companyId) {
        this.setStatus(this.t("errors.missingCompanyId"), "error");
        return;
      }
      this.setLoading(true);
      this.setStatus("");
      try {
        if (email) {
          await submitEmailBackInStockSubscription({
            email,
            variantId: this.currentVariantId,
            companyId
          });
        }
        let warnings = [];
        if (phoneNumber) {
          let smsBackInStockSubmitted = false;
          try {
            await submitSmsBackInStockSubscription({
              phoneNumber,
              variantId: this.currentVariantId,
              companyId
            });
            smsBackInStockSubmitted = true;
          } catch (error) {
            if (!email) {
              throw error;
            }
            warnings.push(this.t("warnings.smsSubscriptionFailed"));
          }
          if (smsBackInStockSubmitted) {
            try {
              await submitSmsMarketingConsent({
                phoneNumber,
                smsListId: this.getKlaviyoSmsListId(),
                companyId,
                missingSmsListMessage: this.t("errors.missingSmsListId")
              });
            } catch (error) {
              warnings.push(this.t("warnings.smsSubscriptionFailed"));
            }
          }
        }
        if (acceptsMarketing) {
          try {
            await submitEmailMarketingConsent({
              email,
              emailListId: this.getKlaviyoEmailListId(),
              companyId
            });
          } catch (error) {
            warnings.push(this.t("warnings.emailMarketingConsentFailed"));
          }
        }
        let successMessage = this.t("success.subscribed");
        if (email && phoneNumber) {
          successMessage = this.t("success.subscribedEmailSms");
        } else if (email) {
          successMessage = this.t("success.subscribedEmail");
        } else if (phoneNumber) {
          successMessage = this.t("success.subscribedSms");
        }
        const warningPrefix = phoneNumber && !email ? this.t("warnings.however") : this.t("warnings.partialPrefix");
        const warningMessage = warnings.length > 0 ? ` ${warningPrefix} ${warnings.join(this.t("warnings.separator"))}.` : "";
        this.setStatus(`${successMessage}${warningMessage}`, "success");
        this.form.reset();
        this.clearPhoneError();
        this.dispatchEvent(
          new CustomEvent("back-in-stock:subscribed", {
            bubbles: true,
            detail: {
              variantId: this.currentVariantId,
              channel: phoneNumber ? "EMAIL_SMS" : "EMAIL"
            }
          })
        );
      } catch (error) {
        this.setStatus(
          error.message || this.t("errors.genericSubmitFailed"),
          "error"
        );
      } finally {
        this.setLoading(false);
      }
    }
    getKlaviyoCompanyId() {
      return this.dataset.companyId || null;
    }
    getKlaviyoSmsListId() {
      return this.dataset.smsListId || null;
    }
    getKlaviyoEmailListId() {
      return this.dataset.emailListId || null;
    }
    setLoading(isLoading) {
      if (!this.submitButton) {
        return;
      }
      this.submitButton.toggleAttribute("disabled", isLoading);
      this.submitButton.setAttribute("aria-busy", String(isLoading));
    }
    resetDialogForm() {
      this.setLoading(false);
      this.setStatus("");
      this.clearPhoneError();
      if (!this.form) {
        return;
      }
      this.form.reset();
      this.form.querySelectorAll(".input__field.is-filled").forEach((input) => {
        input.classList.remove("is-filled");
      });
    }
    setStatus(message, state = "") {
      if (!this.statusElement) {
        return;
      }
      this.statusElement.textContent = message;
      if (state) {
        this.statusElement.dataset.state = state;
      } else {
        delete this.statusElement.dataset.state;
      }
    }
    setPhoneError(message) {
      var _a;
      if (!this.phoneErrorElement) {
        this.setStatus(message, "error");
        return;
      }
      this.phoneErrorElement.textContent = message;
      this.phoneErrorElement.hidden = !message;
      (_a = this.phoneInput) == null ? void 0 : _a.setAttribute("aria-invalid", "true");
    }
    clearPhoneError() {
      var _a;
      if (!this.phoneErrorElement) {
        return;
      }
      this.phoneErrorElement.textContent = "";
      this.phoneErrorElement.hidden = true;
      (_a = this.phoneInput) == null ? void 0 : _a.removeAttribute("aria-invalid");
    }
  };
  if (!customElements.get("back-in-stock")) {
    customElements.define("back-in-stock", BackInStock);
  }
})();
